
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/migration-guide/mparticle-braze",
      function () {
        return require("private-next-pages/events/migration-guide/mparticle-braze.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/migration-guide/mparticle-braze"])
      });
    }
  